import { ArrowLeftIcon, Button } from '@/shared/ui'
import type { CatalogComponentEntry } from './component-registry.types'

export const buttonVariantEntries: CatalogComponentEntry[] = [
  {
    name: 'Button / Filled Pink (variant="primary")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Primary CTA with filled pink background.',
    component: Button,
    render: () => <Button variant="primary">Primary</Button>,
  },
  {
    name: 'Button / Filled Pink Mobile (variant="primaryMobile")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Mobile primary CTA with filled pink background.',
    component: Button,
    render: () => <Button variant="primaryMobile">Primary Mobile</Button>,
  },
  {
    name: 'Button / Filled Pink Mobile B2B (variant="primaryMobileB2B")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Mobile B2B primary CTA with filled pink background.',
    component: Button,
    render: () => <Button variant="primaryMobileB2B">Primary Mobile B2B</Button>,
  },
  {
    name: 'Button / Ghost (variant="secondaryAssist")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Ghost action button with light background (secondaryAssist).',
    component: Button,
    render: () => <Button variant="secondaryAssist">Assist</Button>,
  },
  {
    name: 'Button / Filled Grey (variant="secondarySubmit")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Filled grey submit button (secondarySubmit).',
    component: Button,
    render: () => <Button variant="secondarySubmit">Submit</Button>,
  },
  {
    name: 'Button / Filled Grey Mobile (variant="secondarySubmitMobile")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Mobile filled grey submit button (secondarySubmitMobile).',
    component: Button,
    render: () => <Button variant="secondarySubmitMobile">Submit Mobile</Button>,
  },
  {
    name: 'Button / Outline Thin (variant="tertiaryCancel")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Outline button with thin border (tertiaryCancel).',
    component: Button,
    render: () => <Button variant="tertiaryCancel">Cancel</Button>,
  },
  {
    name: 'Button / Outline Icon (variant="tertiaryCancelIcon")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Icon-only outline button (tertiaryCancelIcon).',
    component: Button,
    render: () => (
      <Button variant="tertiaryCancelIcon" aria-label="Cancel">
        <ArrowLeftIcon className="h-8 w-8" aria-hidden="true" />
      </Button>
    ),
  },
  {
    name: 'Button / Solid Grey Pill (variant="tertiaryMovement")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Solid grey pill used for navigation (tertiaryMovement).',
    component: Button,
    render: () => <Button variant="tertiaryMovement">Movement</Button>,
  },
  {
    name: 'Button / Outline Pill (variant="destructiveCancelRenewal")',
    path: 'shared/ui/button',
    layer: 'shared',
    description: 'Outline pill button with destructive tone (variant="destructiveCancelRenewal").',
    component: Button,
    render: () => <Button variant="destructiveCancelRenewal">Cancel Renewal</Button>,
  },
]
